<template>
<div class="chapter">
<div class="inner_page">
<p class="tit2"><a id="ch00_fm04_ded"></a><a id="page_v"></a><em>For Amira and Sivan</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_ded.vue?3cd5032c